import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { casesData } from '@/mocks/pages';
import { htmlToDesc } from '@/utils/text';
import { getNewsList, type NewsItem } from '@/api/cases';

function CasesPage() {
  const [cases, setCases] = useState<NewsItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getNewsList({ pageNum: 1, pageSize: 100 })
      .then((res) => setCases(res.rows ?? []))
      .catch((e) => setError(e.message || '加载失败'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <section className="relative w-full h-[350px] md:h-[400px] overflow-hidden">
        <div className="absolute inset-0 bg-primary-950/85 z-0" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/40 z-[1]" />
        <div className="absolute inset-0 z-[1]">
          <img
            src="/images/banner-bg.jpg"
            alt="客户案例"
            className="w-full h-full object-cover object-top opacity-35"
          />
        </div>
        <div className="relative z-10 h-full flex flex-col items-center justify-center px-4 md:px-8 text-center">
          <div className="w-full max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-5xl font-extrabold text-white tracking-tight leading-tight mb-4">{casesData.heroTitle}</h1>
            <p className="text-lg md:text-xl text-white/80 font-light mb-3">{casesData.heroSubtitle}</p>
            <p className="text-sm md:text-base text-white/60 max-w-2xl mx-auto">{casesData.heroDesc}</p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
        <div className="max-w-7xl mx-auto">
          {loading ? (
            <p className="text-center text-foreground-400 py-12">加载中…</p>
          ) : error ? (
            <p className="text-center text-red-500 py-12">{error}</p>
          ) : cases.length === 0 ? (
            <p className="text-center text-foreground-400 py-12">暂无案例</p>
          ) : (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
              {cases.map((c) => (
                <Link to={`/support/cases/${c.newsId}`} key={c.newsId} className="bg-white rounded-2xl border border-background-200 overflow-hidden hover:border-primary-200 hover:shadow-md transition-all duration-300 flex flex-col lg:flex-row cursor-pointer">
                  <div className="w-full lg:w-44 h-44 lg:h-auto flex-shrink-0 overflow-hidden">
                    <img src={c.newsCover} alt={c.newsTitle} className="w-full h-full object-cover object-top" />
                  </div>
                  <div className="p-5 md:p-6 flex flex-col">
                    <h3 className="text-base font-bold text-foreground-900 mb-2">{c.newsTitle}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed mb-4 flex-1">{htmlToDesc(c.newsContent)}</p>
                    <div className="flex flex-wrap gap-2">
                      {c.newsKeywords?.split(/[，,]/).filter(Boolean).map((s, si) => (<span key={si} className="px-3 py-1 text-xs font-medium bg-primary-50 text-primary-600 rounded-full whitespace-nowrap">{s.trim()}</span>))}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="py-12 md:py-16 px-4 md:px-8 lg:px-12 bg-primary-500">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">想成为我们的下一个成功案例？</h2>
          <p className="text-white/75 text-sm md:text-base mb-8">联系我们，获取专属 AI 翻译解决方案</p>
          <a href="/contact" className="inline-flex items-center px-8 py-3.5 bg-white text-primary-600 text-sm md:text-base font-semibold rounded-full hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"><i className="ri-mail-send-line mr-2"></i>立即咨询</a>
        </div>
      </section>
    </>
  );
}

export default CasesPage;